import styled from 'styled-components';
export const KeyboardHintLine = styled.p `
  color: rgba(0, 0, 0, 0.5);
  padding: 1rem;
`;
